<template>
  <section class="footer" id="footer">
    <div class="container" @click="mostraRodape()">
      <div class="col-xs-12 col-sm-6 info-content">
        <div class="info">
          <p class="title">ERROS NO SITE?</p>
          <address>
            <p>
              Entre em contato através do email: <br />
              <a href="mailto:portaldatransparencia@santos.sp.gov.br">
                portaldatransparencia@santos.sp.gov.br
              </a>
            </p>
          </address>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 info-content">
        <div class="info">
          <p class="title">OUVIDORIA</p>
          <address>
            <p>
              Paço Municipal<br />
              Praça Visconde de Mauá, s/n<br />
              Piso Térreo<br />
              Cep: 11010-900<br />
              Tel.: <a href="tel:162">162</a>
            </p>
          </address>
        </div>
      </div>
      <div class="col-xs-12" style="padding-top: 15px">
        <p style="text-align: center">
          Prefeitura Municipal de Santos
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'rodape',
  methods: {
    mostraRodape() {
      const html = document.querySelector('html').clientHeight
      const tela = window.innerHeight
      const posicao = window.innerHeight + window.scrollY

      if (tela === posicao) {
        window.scrollTo({ top: html, behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
p.title {
  color: #c1d1c1;
  font-weight: 400;
  margin-bottom: 18px;
  font-size: 1.6em;
  margin-top: 10px;
  line-height: 1.1;
  padding-top: 0px;
}

p {
  line-height: 1.65em;
}

.footer {
  background: #0d291b none repeat scroll 0 0;
  font-size: 1em;
  width: 100%;
  color: #dcf9c1;
  text-align: left;
  padding-top: 10px;
  padding-bottom: 10px;
  position: absolute;
  left: 0;
  top: 100%;
  margin-top: 30px;
}

.info-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.info {
  margin-left: unset;
  margin-right: unset;
}

@media screen and (min-width: 768px) {
  .info {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue